import { GET_TOILETS, GET_TOILET_TYPES, SUCCESS, FAIL } from "../action_types";

const STATE_INIT = {
  isLoading: false,
  isUpdating: false,
  toilets: [],
  toiletTypes: [],
  error: {},
};

export default (state = STATE_INIT, { type, payload }) => {
  switch (type) {
    case GET_TOILETS:
      return { ...state, isLoading: true };
    case `${GET_TOILETS}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        toilets: [...payload],
      };
    case `${GET_TOILETS}_${FAIL}`:
      return { ...state, isLoading: false, error: { ...payload } };

    case GET_TOILET_TYPES:
      return { ...state, isLoading: true };
    case `${GET_TOILET_TYPES}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        toiletTypes: [...payload],
      };
    case `${GET_TOILET_TYPES}_${FAIL}`:
      return { ...state, isLoading: false, error: { ...payload } };

    default:
      return state;
  }
};
